// i18n — v1-ben KIZÁRÓLAG magyar (nincs nyelv-detektor, nincs váltó). A szabály nem a többnyelvűség,
// hanem a hardcode-olt felület-szöveg tilalma: minden szöveg kulcson át megy, így a későbbi `en`
// locale additív (egy új resources-kulcs). Névtér-rétegzés az Atlas-minta szerint:
// translation (felület) · validation (űrlap-hibák) · toast (visszajelzések).
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

export const resources = {
  hu: {
    translation: {
      common: {
        appName: 'MORGENS Hub',
        comingSoon: 'Hamarosan',
        loading: 'Betöltés…',
        logout: 'Kijelentkezés',
        menu: 'Menü',
        theme: 'Téma váltása',
      },
      // Profil — ki vagyok, mi a hozzáférési szintem, mit tehetek.
      //
      // A jog-kulcsok NYERSEN jelennek meg (csoportosítva): a katalógus ember-olvasható,
      // kétnyelvű címkéi az Odinban élnek, és a `packages/shared/src/permissions.ts` tiltja egy
      // második címke-szótár beírását. A CSOPORT-nevek viszont nem címke-szótár: a kulcs
      // `<erőforrás>.<művelet>` szerkezetéből következnek, és ismeretlen erőforrásnál a nyers
      // névre esünk vissza (`group.other`), tehát egy platform-bővítés nem tüntet el jogot.
      profile: {
        title: 'Profil',
        subtitle: 'A saját adataid, a hozzáférési szinted és a jogosultságaid.',
        loadError: 'A profil most nem tölthető be. Frissítsd az oldalt.',
        identity: 'Azonosító adatok',
        name: 'Név',
        nameMissing: '(a bejelentkezés nem adott nevet)',
        email: 'E-mail',
        emailMissing: '(nincs megadva)',
        accessLevel: 'Hozzáférési szint',
        role: {
          member: 'Olvasó (member) — olvasás és hozzászólás.',
          admin: 'Szerkesztő (admin) — a tartalom és a szerkezet kezelése.',
          superadmin: 'Teljes hozzáférés (superadmin) — minden jogosultság.',
          // Ha a jog-halmaz egyik tierrel sem egyezik pontosan (egyedi kiosztás), a felület NEM
          // közelít egy tier-névre: a lista marad az igazság.
          custom: 'Egyedi jogosultság-készlet — a pontos listát lásd alább.',
        },
        platformAdmin: 'Platform-adminisztrátor: a felület minden funkciót megmutat.',
        permissions: 'Jogosultságok',
        permissionsEmpty: 'Ehhez a fiókhoz nincs jogosultság rendelve.',
        permissionsNote_one: '{{count}} jogosultság. Frissen kapott jog a következő belépés után jelenik meg.',
        permissionsNote_other:
          '{{count}} jogosultság. Frissen kapott jog a következő belépés után jelenik meg.',
        group: {
          article: 'Cikkek',
          space: 'Szekciók',
          category: 'Könyvek',
          comment: 'Hozzászólások',
          revision: 'Változatok',
          gap: 'Tudás-hiányok',
          knowledge: 'Tudástár-hozzáférés',
          other: '{{resource}}',
        },
      },
      login: {
        title: 'Üdv újra!',
        subtitle: 'Jelentkezz be a Morgens tudástárba.',
        email: 'E-mail',
        password: 'Jelszó',
        showPassword: 'Jelszó megjelenítése',
        hidePassword: 'Jelszó elrejtése',
        forgot: 'Elfelejtett jelszó?',
        remember: 'Emlékezz rám',
        submit: 'Belépés',
        submitting: 'Belépés…',
        errInvalid: 'Hibás e-mail vagy jelszó.',
        errUnavailable: 'A bejelentkezés átmenetileg nem elérhető — próbáld újra pár perc múlva.',
        errRateLimited: 'Túl sok próbálkozás — várj egy percet, mielőtt újra próbálkozol.',
        errFailed: 'A belépés nem sikerült — próbáld újra.',
        heroLine1: 'A Morgens tudása,',
        heroLine2: 'egy helyen.',
        heroBody:
          'Kereshető céges tudástár: dokumentációk, folyamatok és súgó-cikkek — AI-válasszal, forrás-hivatkozásokkal.',
      },
      // Sablon-kezelő (Karbantartás-szintű, szerkesztőségi eszköz).
      templates: {
        open: 'Sablonok',
        title: 'Sablonok',
        backToList: 'Vissza a sablonokhoz',
        editTitle: '{{name}} szerkesztése',
        subtitle:
          'Cikk-vázak új cikkekhez és beszúrható részletek a szerkesztő oldalsávjába. Amit itt felveszel, azt minden szerkesztő látja.',
        create: 'Új sablon',
        edit: 'Szerkesztés',
        archive: 'Kivezetés',
        archiveConfirm:
          'Kivezeted ezt a sablont? Nem fog megjelenni a felajánlásban, de a története megmarad.',
        empty: 'Még nincs sablon. Vegyél fel egyet — a szerkesztők azonnal látni fogják.',
        loadError: 'A sablonok most nem tölthetők be. Frissítsd az oldalt.',
        fieldKind: 'Fajta',
        kindArticle: 'Cikk-váz (új cikkhez)',
        kindSnippet: 'Részlet (beszúrható)',
        fieldName: 'Név',
        fieldDescription: 'Mikor használd',
        fieldBody: 'Tartalom',
        fieldPosition: 'Sorrend',
        save: 'Mentés',
        cancel: 'Mégse',
        saved: 'A sablon elmentve.',
        archived: 'A sablon kivezetve.',
        nameRequired: 'A sablonnak adj nevet.',
        // Az ÚJ CIKK oldal váz-választója.
        pickTitle: 'Miből induljon?',
        pickEmpty: 'Üres cikk',
        pickEmptyHint: 'Tiszta lappal kezdesz.',
      },
      nav: {
        home: 'Kezdőlap',
        knowledge: 'Tudástár',
        help: 'Súgó',
        editing: 'Szerkesztés',
        publishing: 'Publikálás',
        admin: 'Adminisztráció',
      },
      // A lábléc: a belső felület alján a KÜLSŐ (nyilvános) súgó belépője. Külön névtér, mert nem
      // menüpont — lásd `lib/nav.ts` kommentjét arról, miért került ki a felső sávból.
      footer: {
        helpLink: 'MORGENS Hub súgó — a nyilvános felület',
        helpConfirm:
          'Átlépsz a MORGENS Hub NYILVÁNOS súgójára, amit bejelentkezés és hozzáférés nélkül bárki elér. Csak a nyilvánosra állított tartalom látszik ott. Folytatod?',
      },
      search: {
        title: 'Keresés',
        placeholder: 'Keresés a tudástárban…',
        placeholderShort: 'Keresés…  /',
        // M7: az eredeti szöveg ("a kereső a cikkek teljes szövegében keres") elavult "Címben"
        // módban — ott épp NEM a törzsben, hanem a cím(ek)ben keres. Semleges, hatókör-független
        // megfogalmazásra cserélve, hogy mindhárom módban igaz maradjon.
        hint: 'Írj be egy kifejezést — a hatókör fent állítható (mindenben / címben / tartalomban).',
        empty: 'Nincs találat erre: „{{query}}".',
        resultCount: '{{count}} találat',
        allSpaces: 'Mind ({{count}})',
        degraded: 'A keresés átmenetileg nem elérhető. A tartalom böngészése továbbra is működik.',
        error: 'A keresés nem sikerült — próbáld újra.',
        scope: {
          all: 'Mindenben',
          title: 'Címben',
          content: 'Tartalomban',
          // M7: a radiogroup aria-labelje eddig `search.title` ("Keresés") volt — ez nem a
          // HATÓKÖRT nevezte meg, csak megismételte az oldal címét. Beszédes, dedikált kulcs.
          label: 'Keresés hatóköre',
        },
        /** Struktúra-találat badge — a könyv/szekció CÍME illeszkedett a kifejezésre. */
        kind: {
          category: 'Könyv',
          space: 'Szekció',
        },
      },
      home: {
        title: 'Kezdőlap',
        hero: 'Mit keresel?',
        heroNamed: 'Mit keresel, {{name}}?',
        heroSubtitle: '{{articles}} cikk {{spaces}} szekcióban — termékek, folyamatok és eszközök.',
        heroSubtitleFallback: 'Termékek, folyamatok és eszközök egy helyen.',
        popularTags: 'Gyakori:',
        spaces: 'Szekciók',
        allSpaces: 'Összes szekció ({{count}})',
        entries: 'Hova tovább',
        knowledgeTitle: 'Tudástár',
        knowledgeBody: 'A teljes katalógus: szekciók, könyvek, cikkek.',
        helpTitle: 'Súgó',
        helpBody: 'A nyilvános cikkek — ezt látják az ügyfelek, belépés nélkül.',
        newArticleBody: 'Vázlat létrehozása egy könyvben; a publikálás külön lépés.',
        structureBody: 'Szekciók és könyvek létrehozása, átnevezése, archiválása.',
      },
      noAccess: {
        title: 'Nincs hozzáférésed a tudástárhoz',
        body: 'A fiókod nem kapott „Cikkek megtekintése" jogot. Kérd az adminisztrátortól — a jogosultságokat az Atlasban állítják.',
      },
      errorPage: {
        title: 'Valami elromlott',
        body: 'A hiba naplózva. Próbáld újratölteni az oldalt, vagy térj vissza a kezdőlapra.',
        home: 'Vissza a kezdőlapra',
      },
      knowledge: {
        title: 'Tudástár',
        subtitle: 'Minden szekció egy helyen — szűkíts a névre, vagy nyiss meg egyet.',
        searchPlaceholder: 'Mit keresel?',
        searchHint: 'Nyomj Entert a teljes szövegű kereséshez: „{{query}}"',
        stats: '{{spaces}} szekció · {{articles}} cikk',
        emptyBadge: 'Üres',
        emptySpaceHint: 'Ebben a szekcióban még nincs egyetlen cikk sem.',
        // A vázlat 2026-08-14 óta LÁTSZIK a belső nézetben (a publikus súgóban soha) — jelölés
        // nélkül publikáltnak látszana, ami félrevezető. Ugyanaz a pill-minta, mint az „Üres"-nél.
        draftBadge: 'Vázlat',
        // Az ikonok neve — EGYBEN a tooltip szövege és a felolvasónak adott `aria-label`.
        publishedIcon: 'Publikált',
        publicIcon: 'Nyilvánosan elérhető',
        draftHint: 'Ez a cikk még vázlat — csak bejelentkezve látható, a publikus súgóban nem.',
        newCategoryPromptTitle: '„{{name}}" szekció létrehozva.',
        newCategoryPromptBody: 'A cikkekhez előbb egy könyv kell benne.',
        newCategoryPromptAction: 'Könyv létrehozása',
        newCategoryPromptDismiss: 'Most nem',
        // A könyv-sorban ÉS az üres-könyv állapot kiemelt CTA-jában is ez a felirat — ugyanaz a
        // művelet, más súly (lásd `category-create-article-link.tsx`).
        newArticleInBook: 'Cikk létrehozása',
        otherSpaces: 'Továbbiak',
        allSpaces: 'Minden szekció',
        inThisSpace: 'Ebben a szekcióban',
        breadcrumbLabel: 'Kenyérmorzsa',
        categoryCount: '{{count}} könyv',
        articleCount: '{{count}} cikk',
        spaceCount: '{{count}} szekció',
        toc: 'Ezen az oldalon',
        updated: 'Frissítve: {{date}}',
        readingTime: '{{minutes}} perc olvasás',
        tags: 'Címkék',
        tagTitle: '„{{tag}}" címke',
        tagSubtitle: 'A címkéhez tartozó cikkek, szekció szerint csoportosítva.',
        tagEmpty: 'Ehhez a címkéhez nincs cikk.',
        emptyHome: 'Még nincs tartalom a tudástárban.',
        emptySpace: 'Ebben a szekcióban még nincs könyv.',
        emptyCategory: 'Ebben a könyvben még nincs cikk.',
        notFound: 'A keresett cikk nem található — lehet, hogy törölték vagy áthelyezték.',
        backHome: 'Vissza a tudástárba',
        treeLabel: 'Tartalom-fa',
        filterPlaceholder: 'Szűrés a szekciók közt…',
        treeAll: 'Teljes tudástár',
        treeFilterPlaceholder: 'Szűrés: szekció, könyv vagy cikk neve…',
        articleFilterPlaceholder: 'Cikk szűrése a címben…',
        articleShownOf: '{{shown}} / {{total}}',
        sortByTitle: 'Cím szerint',
        sortByRecent: 'Legutóbb módosított',
        tooManyArticles: '{{count}} cikk ebben a könyvben — érdemes szétbontani.',
        treeExpand: 'Kinyitás',
        treeCollapse: 'Összecsukás',
        filterEmpty: 'Nincs „{{filter}}" nevű szekció.',
        recent: 'Legutóbb frissítve',
        // A lábléc-nav a lapozón KÍVÜL a könyv-linket is tartalmazza — a címke ezért „navigáció”.
        articleNav: 'Cikk-navigáció',
        previousArticle: 'Előző',
        nextArticle: 'Következő',
        upToBook: 'Vissza a könyvhöz: {{book}}',
        publicView: 'Publikus nézet',
        treeToggle: 'Navigáció',
        loadError: 'A tartalom betöltése nem sikerült — próbáld újra.',
        // Kép teljes méretben (cikk-nézet és publikus súgó — ugyanaz a komponens).
        lightbox: {
          /** A kép-gomb neve. Alt-szöveg nélküli képnél a `open` a tartalék. */
          open: 'Kép megnyitása teljes méretben',
          openNamed: 'Kép megnyitása teljes méretben: {{alt}}',
          /** A párbeszédablak neve képernyőolvasónak (alt-szöveg nélküli képnél). */
          title: 'Kép teljes méretben',
          close: 'Bezárás',
        },
      },
      editor: {
        title: 'Cikk szerkesztése',
        loadError: 'A cikk betöltése nem sikerült.',
        notFound: 'A szerkesztendő cikk nem található.',
        fieldTitle: 'Cím',
        fieldSummary: 'Összefoglaló',
        fieldSummaryHint: 'Egy-két mondat: ez jelenik meg a listákban és a találatoknál.',
        fieldTags: 'Címkék',
        fieldTagsHint: 'Vesszővel elválasztva.',
        fieldBody: 'Tartalom (markdown)',
        fieldChangeNote: 'Változás megjegyzése',
        fieldChangeNotePlaceholder: 'Mit módosítottál? (a revízió-listában jelenik meg)',
        preview: 'Előnézet',
        previewEmpty: 'Az előnézet itt jelenik meg, ahogy gépelsz.',
        edit: 'Szerkesztés',
        save: 'Mentés',
        /** Művelet-megnevezés a hibaüzenet-kontextushoz. */
        saveFailedOperation: 'A mentés nem sikerült',
        saving: 'Mentés…',
        cancel: 'Mégse',
        back: 'Vissza a cikkhez',
        // A szószám a MARKDOWN törzsből számol (a jelölés-tokenek is szónak számítanak) — a cél a
        // terjedelem nagyságrendje, nem szerkesztői pontosság.
        wordCount: '{{words}} szó',
        status: {
          draft: 'Vázlat',
          published: 'Publikált',
          archived: 'Archivált',
          deleted: 'Törölt',
        },
        autosave: {
          idle: 'Minden változás elmentve',
          saving: 'Vázlat mentése…',
          saved: 'Vázlat elmentve {{time}}',
          failed: 'A vázlat mentése nem sikerült',
        },
        draftBanner: {
          title: 'Mentetlen vázlatod van ({{time}})',
          body: 'Legutóbb elkezdted szerkeszteni ezt a cikket, de nem mentetted el. Betöltöd a vázlatot, vagy eldobod?',
          load: 'Vázlat betöltése',
          discard: 'Eldobás',
        },
        conflict: {
          title: 'A cikket időközben más is módosította',
          body: 'A mentés nem történt meg, hogy ne írd felül a másik szerkesztést. A szövegedet nem veszítetted el — másold ki, amit meg akarsz tartani, majd tölts újra.',
          reload: 'Újratöltés a friss változattal',
          theirVersion: 'Jelenlegi mentett cím: „{{title}}" ({{time}})',
        },
        unsavedWarning: 'Nem mentett módosításaid vannak.',
        mode: {
          label: 'Szerkesztő módja',
          visual: 'Vizuális',
          markdown: 'Markdown',
          html: 'HTML',
        },
        // BESZÚRÓ OLDALSÁV (1. fázis) — kész elemek a kurzorhoz. A nevek a SZERZŐ nyelvén szólnak
        // („Figyelmeztetés", nem „warning callout"): a felület a nem-technikás kollégának készül.
        insert: {
          // A SÁV neve „Beszúrás", a két FÜLE „Elemek" és „Sablonok". Korábban a sáv és az egyik
          // füle is „Elemek" volt — bejelentve, hogy így nem található meg a Sablonok fül.
          title: 'Beszúrás',
          hide: 'Beszúró sáv elrejtése',
          show: 'Beszúrás',
          groupCallout: 'Kiemelt dobozok',
          groupInline: 'Szövegen belül',
          groupBlock: 'Blokkok',
          calloutInfo: 'Megjegyzés',
          calloutWarning: 'Figyelmeztetés',
          calloutDanger: 'Fontos',
          calloutSuccess: 'Tipp',
          calloutPlaceholder: 'Írd ide a megjegyzést…',
          menuName: 'Menüpont neve',
          menuNamePlaceholder: 'Beállítások',
          menuPath: 'Menü-útvonal',
          menuPathPlaceholder: 'Beállítások › E-mailek',
          figure: 'Kép + képaláírás',
          figureCaption: 'Írd ide a képaláírást…',
          // A sáv két füle: a kódban élő ELEMEK és a szerkesztőség által karbantartott SABLONOK.
          tabBlocks: 'Elemek',
          tabTemplates: 'Sablonok',
          // A menüpont neve SABLONOK — korábban itt „Karbantartás" állt, ami rossz helyre küldte
          // a szerzőt (a menüpont-döntés a szöveg megírása után született).
          templatesEmpty: 'Még nincs beszúrható sablon. A Sablonok menüpontban vehetsz fel újat.',
          templatesError: 'A sablonok most nem tölthetők be.',
          templatesLoading: 'Sablonok betöltése…',
        },
        // HTML-forrás mód (T5). A tárolt alak VÁLTOZATLANUL markdown + HTML-szigetek — ez nézet,
        // nem új formátum. A figyelmeztetés a mentés előtt nevezi meg, mit dobna el a sanitize.
        html: {
          editorLabel: 'HTML-forrás',
          lossTitle: 'A mentés ezeket nem tartja meg:',
          lossTags: 'elemek: {{names}}',
          lossAttributes: 'attribútumok: {{names}}',
          hint: 'A tárolt tartalom markdown, HTML-szigetekkel. Ez a nézet a migrált táblázatok és a beágyazott HTML kézi javításához való.',
        },
        visual: {
          // A vizuális (WYSIWYG) szerkesztő eszköztár-gombjai — mindegyik `aria-label`-ként is
          // szolgál, tehát a szöveg egyszerre felirat és képernyőolvasó-bejelentés.
          // Az `editorLabel` a szerkeszthető felület (a ProseMirror contenteditable) accessible
          // name-je — enélkül a felület névtelen `textbox` lenne, és a markdown-mezőtől (`fieldBody`)
          // sem lenne megkülönböztethető a teszt-lekérdezésekben.
          editorLabel: 'Cikktörzs szerkesztése',
          // I-2 (review-lelet): a lazy-betöltött TipTap-csomag hibájánál (VisualEditorBoundary)
          // jelenik meg — a felhasználó munkája nem vész el, markdown módban folytatható.
          loadError: 'A vizuális szerkesztő nem tölthető be — markdown módban folytathatod.',
          bold: 'Félkövér',
          italic: 'Dőlt',
          heading2: 'Címsor 2',
          heading3: 'Címsor 3',
          bulletList: 'Felsorolás',
          orderedList: 'Számozott lista',
          link: 'Link',
          linkPrompt: 'Add meg a link célját (URL):',
          quote: 'Idézet',
          codeBlock: 'Kódblokk',
          image: 'Kép beszúrása',
          // Kép-átméretezés a szerkesztőben. A tárolt méret PIXELES szélesség; a magasság
          // törlődik, hogy az arány a böngészőre maradjon (a cikk-nézet `h-auto max-w-full`-t ad,
          // tehát keskeny kijelzőn a nagy kép magától zsugorodik).
          imageResize: {
            handle: 'Kép átméretezése húzással',
            smaller: 'Kisebb',
            larger: 'Nagyobb',
            reset: 'Eredeti méret',
            // A világos alátét kapcsolója. NEM automatika: lásd a `sanitize-schema.ts`
            // `data-plate` kommentjét arról, miért a szerző dönti el.
            plateOn: 'Világos alátét bekapcsolása',
            plateOff: 'Világos alátét kikapcsolása',
            width: '{{px}} px',
            // Alt-szöveg: a képernyőolvasók ezt mondják fel a kép helyett. „Leíró szöveg", nem
            // „alt" — a szerkesztőség nem HTML-attribútum-nevekben gondolkodik.
            altLabel: 'Leíró szöveg (képernyőolvasónak)',
            altPlaceholder: 'Mit ábrázol a kép?',
          },
          undo: 'Visszavonás',
          redo: 'Újra',
          strike: 'Áthúzás',
          inlineCode: 'Kód a szövegben',
          taskList: 'Ellenőrzőlista',
          paragraph: 'Sima bekezdés',
          // Igazítás. A BALRA az alapállapot: a gomb nem beállít, hanem TÖRLI a jelölést —
          // ezért nem kap aktív-jelzést sem (a szöveg túlnyomó része balra igazított, az állandó
          // kiemelés jelentés nélküli zaj lenne, mint a „Sima bekezdés" gombnál).
          alignLeft: 'Balra igazítás',
          alignCenter: 'Középre igazítás',
          alignRight: 'Jobbra igazítás',
          // BETŰMÉRET a kijelölt szövegrészen. A méret SZÁMKÉNT tárolódik (`data-size`), a stílust
          // a render teszi rá — nyers `style` attribútum nem juthat a tartalomba.
          fontSize: 'Betűméret (px)',
          fontSizeDecrease: 'Kisebb betű',
          fontSizeIncrease: 'Nagyobb betű',
          fontSizeReset: 'Alapméret',
          // Az eszköztár-sávok accessible name-je: a `role="toolbar"` nyíl-navigációval egyetlen
          // tabulátor-megállás, tehát a képernyőolvasónak a sáv NEVE mondja meg, mibe lépett be.
          toolbarLabel: 'Formázás',
          // Az inline link-sáv (a natív `window.prompt` helyett) — lásd a komponens kommentjét arról,
          // miért NEM `<form>` a sáv.
          linkBar: {
            label: 'Link célja',
            placeholder: 'https://…',
            apply: 'Link beszúrása',
            // A sanitize-allowlist (`sanitize-schema.ts` `protocols`) csak http/https/mailto sémát
            // engedi át — enélkül a szerkesztőben látszó link a mentésnél NÉMÁN eltűnne. A saját
            // (relatív) hivatkozást és a horgonyt is engedjük: azoknak nincs sémájuk.
            invalid: 'Csak http, https vagy mailto cím adható meg (vagy „/”-rel kezdődő saját hivatkozás).',
            remove: 'Link eltávolítása',
            cancel: 'Mégse',
          },
          table: {
            insert: 'Táblázat beszúrása',
            addRow: 'Sor hozzáadása',
            deleteRow: 'Sor törlése',
            addColumn: 'Oszlop hozzáadása',
            deleteColumn: 'Oszlop törlése',
            mergeCells: 'Cellák összevonása',
            splitCell: 'Cella szétválasztása',
            // A táblázat-műveletek KONTEXTUSOS sávja: csak akkor jelenik meg, ha a kurzor táblázatban
            // van. A csoport-feliratok („Sor", „Oszlop", „Cella") a látható szöveg; a gombok
            // `aria-label`-je a fenti, teljes megnevezés marad — enélkül a képernyőolvasó csak
            // annyit mondana: „plusz".
            toolbarLabel: 'Táblázat-műveletek',
            groupRow: 'Sor',
            groupColumn: 'Oszlop',
            groupCell: 'Cella',
          },
        },
      },
      lifecycle: {
        title: 'Állapot',
        /** Művelet-megnevezés a hibaüzenet-kontextushoz. */
        operation: 'Az állapot módosítása nem sikerült',
        publish: 'Publikálás',
        unpublish: 'Publikálás visszavonása',
        archive: 'Archiválás',
        trash: 'Papírkosárba',
        working: 'Folyamatban…',
        confirmArchive:
          'Archiválod a cikket? Kikerül a navigációból és a keresésből, de nem vész el.',
        confirmTrash: 'Papírkosárba teszed a cikket? Később visszaállítható.',
        hintDraft: 'Vázlat — csak a szerkesztők látják.',
        hintPublished: 'Publikálva — minden belépett kolléga látja.',
        hintArchived: 'Archivált: nem jelenik meg a navigációban és a keresésben.',
        hintDeleted: 'A papírkosárban van — az olvasók nem látják.',
        makePublic: 'Nyilvánossá tétel',
        makeInternal: 'Nyilvánosság visszavonása',
        publicBadge: 'Nyilvános',
        confirmPublic:
          'Nyilvánossá teszed? A cikk bejelentkezés nélkül is elérhető lesz a súgóban.',
        // A nyilvánosság HIERARCHIKUS: a súgóra csak akkor kerül ki bármi, ha a szekció, a könyv és
        // a cikk MINDHÁROM nyilvános. Ezek a szövegek megnevezik a hiányzó szintet — enélkül a
        // szerkesztő azt hiszi, kikerült a tartalom (élő eset, 2026-08-24).
        blockedBySpace:
          'Nyilvánosra állítva, de NEM érhető el a súgóban: a „{{name}}” szekció belső. A szekciót (és a könyvet) is nyilvánossá kell tenni.',
        blockedByCategory:
          'Nyilvánosra állítva, de NEM érhető el a súgóban: a „{{name}}” könyv belső. A könyvet is nyilvánossá kell tenni.',
        confirmPublicBlocked:
          'FIGYELEM: a szekció vagy a könyv még belső, ezért ettől a lépéstől a cikk MÉG NEM lesz elérhető a súgóban.',
      },
      public: {
        title: 'Súgó',
        hero: 'Miben segíthetünk?',
        subtitle: 'Útmutatók és válaszok a MORGENS termékeihez.',
        searchPlaceholder: 'Mit szeretnél megtudni?',
        searchPlaceholderShort: 'Keresés a súgóban…',
        empty: 'Egyelőre nincs nyilvános cikk.',
        loadError: 'A tartalom betöltése nem sikerült.',
        notFound: 'Ez a cikk nem érhető el nyilvánosan.',
        backToHelp: 'Vissza a súgóhoz',
        internalNote: 'Belső tudástár',
        /** Ugyanaz a tartalom a belső felületen (belépés nélkül a login-on át, ide visszatérve). */
        internalView: 'Megnyitás a belső tudástárban',
      },
      newArticle: {
        /** Művelet-megnevezés a hibaüzenet-kontextushoz. */
        failedOperation: 'A cikk létrehozása nem sikerült',
        open: 'Új cikk',
        title: 'Új cikk',
        subtitle: 'Válaszd ki, hova kerüljön, és add meg a címét. A tartalom a következő lépés.',
        fieldSpace: 'Szekció',
        fieldCategory: 'Könyv',
        newSpace: 'Új szekció',
        newCategory: 'Új könyv',
        // A létrehozás HELYBEN történik: az adott sor választója beviteli mezőre cserélődik. A mező
        // neve (`aria-label`) és a jóváhagyó gomb felirata is kimondja, MIT hozunk létre — a lap
        // alján álló „Létrehozás" a CIKKET hozza létre, a kettő nem keverhető össze.
        spaceNameLabel: 'Szekció neve',
        categoryNameLabel: 'Könyv neve',
        createSpaceAction: 'Szekció létrehozása',
        createCategoryAction: 'Könyv létrehozása',
        firstSpaceAction: 'Első szekció létrehozása',
        newSpaceHint:
          'Az új szekció üres lesz — mindjárt a könyvet is megkérjük hozzá, mert cikk csak könyvbe kerülhet.',
        newCategoryHint: 'Az új könyv a „{{space}}" szekcióban jön létre.',
        fieldTitle: 'Cím',
        titlePlaceholder: 'Miről szól a cikk?',
        create: 'Létrehozás',
        creating: 'Létrehozás…',
        noCategory: 'Ebben a szekcióban még nincs könyv — előbb hozz létre egyet.',
        emptyStructure: 'Még nincs szekció, ahova cikket lehetne tenni.',
        hint: 'A cikk vázlatként jön létre; csak akkor lesz látható, ha publikálod.',
      },
      trash: {
        // NÉV (2026-08-28, projekt-tulajdonosi döntés): a „Kuka" túl nyers egy céges tudástárban.
        // A „Papírkosár" ugyanazt a — mindenki által ismert — metaforát viszi, csak a hangnem
        // illeszkedik a felület többi részéhez.
        /** Művelet-megnevezés a hibaüzenet-kontextushoz. */
        restoreOperation: 'A visszaállítás nem sikerült',
        open: 'Papírkosár',
        title: 'Papírkosár',
        subtitle: 'A papírkosárba tett cikkek. Semmi nem veszett el — bármelyik visszaállítható.',
        empty: 'A papírkosár üres.',
        restore: 'Visszaállítás',
        deletedAt: 'papírkosárba téve: {{date}}',
        unknownPlace: 'ismeretlen hely',
        loadError: 'A papírkosár betöltése nem sikerült.',
        hint: 'A visszaállított cikk VÁZLATKÉNT jön vissza, tehát külön publikálni kell:',
      },
      operations: {
        // NÉV (2026-08-25): az „Üzemeltetés" nem mondta meg, mi van mögötte. A lap négy kérdésre
        // válaszol — működik-e a rendszer, mennyi tartalom van, mi látszik kívülről, és mit nem
        // találnak meg az emberek —, ezért a menü a TEVÉKENYSÉGET nevezi meg, a lap-cím pedig a
        // két felét.
        open: 'Karbantartás',
        title: 'Karbantartás és rendszerállapot',
        subtitle:
          'A rendszer állapota, a tartalom mérete és nyilvánossága, a keresőindex és a hiánynapló egy helyen. Jogokat az Atlasban lehet osztani.',
        // ── Rendszerállapot (a publikus életjel-végpontból) ──
        healthTitle: 'Rendszerállapot',
        healthOdin: 'Odin-kapcsolat',
        // NEM „Keresőindex": az életjel az index-adatbázis KAPCSOLATÁRÓL szól (be van-e kötve),
        // nem a tartalmáról — azt az alatta lévő index-szekció mutatja. A két név összekeverése a
        // felületen is félrevezetne, nem csak a teszt-lekérdezésekben.
        healthIndex: 'Index-kapcsolat',
        healthUptime: 'Folyamatos futás',
        healthLoadError: 'A rendszerállapot nem tölthető be.',
        healthOdinOk: 'Elérhető',
        healthOdinUnreachable: 'Nem érhető el',
        healthIndexOk: 'Bekötve',
        healthIndexOff: 'Kikapcsolva',
        healthIndexError: 'Hibás',
        // Napokra/órákra bontott futásidő — a nyers másodperc semmit nem mond.
        uptimeDays: '{{days}} nap {{hours}} óra',
        uptimeHours: '{{hours}} óra {{minutes}} perc',
        uptimeMinutes: '{{minutes}} perc',
        // ── Tartalom és nyilvánosság ──
        contentTitle: 'Tartalom és nyilvánosság',
        contentSubtitle:
          'A bal oldali számok a belső tudástárat mutatják, a jobb oldaliak azt, amit bejelentkezés nélkül bárki elér a súgón. A súgóra csak akkor kerül ki egy cikk, ha a szekció, a könyv ÉS a cikk is nyilvános.',
        contentLoadError: 'A tartalom-áttekintő nem tölthető be.',
        contentSpaces: 'Szekció',
        contentCategories: 'Könyv',
        contentArticles: 'Cikk',
        contentInternal: 'Belső tudástár',
        contentPublic: 'Nyilvános súgó',
        contentPublicNone:
          'A súgón jelenleg EGYETLEN szekció sem nyilvános, tehát a nyilvános felület üres — hiába nyilvános egy-egy cikk.',
        contentPublicList: 'Nyilvánosan elérhető szekciók',
        noAccess:
          'Ehhez az oldalhoz tudástár-adminisztrátori jog vagy a tudás-hiányok áttekintésének joga kell.',
        indexTitle: 'Keresőindex',
        indexLoadError: 'Az index állapota nem tölthető be.',
        articles: 'Cikk',
        chunks: 'Szövegrészlet',
        structureRows: 'Könyv/szekció-cím',
        lastRun: 'Utolsó építés',
        never: 'még soha',
        state: 'Állapot',
        stateReady: 'Kész',
        stateRunning: 'Épül…',
        stateOff: 'Kikapcsolva',
        lastError: 'A legutóbbi építés hibája: {{error}}',
        emptyIndexHint:
          'Az index üres — a keresés nem ad találatot, amíg fel nem épül. Az első keresés magától elindítja, de itt kézzel is megteheted.',
        emptyStructureHint:
          'A könyv/szekció-cím index üres, miközben a cikk-index nem az — a "Címben" mód emiatt nem talál könyveket/szekciókat. Egy manuális újraépítés pótolja.',
        rebuild: 'Index újraépítése',
        rebuilding: 'Épül…',
        rebuildHint:
          'A teljes újraépítés az Odinból olvas, és néhány másodpercig tart. Az index eldobható melléktermék — bármikor biztonságosan újraépíthető.',
        rebuildDone: 'Index újraépítve: {{articles}} cikk, {{chunks}} szövegrészlet.',
        rebuildBusy: 'Épp fut egy indexelés — a kérésed abba olvadt bele.',
        rebuildFailed: 'Az index újraépítése nem sikerült.',
        missesTitle: 'Hiánynapló',
        missesSubtitle:
          'Amit hiába kerestek a kollégák — ezekről a témákról érdemes cikket írni. Nem tároljuk, ki kereste.',
        missesEmpty: 'Nincs rögzített eredménytelen keresés.',
        missesLoadError: 'A hiánynapló nem tölthető be.',
        missCount: '{{count}} keresés',
        missWriteArticle: 'Cikk írása erről',
      },
      structure: {
        open: 'Szerkezet',
        /** Művelet-megnevezések a hibaüzenet-kontextushoz. */
        operation: 'A művelet nem sikerült',
        moveOperation: 'Az áthelyezés nem sikerült',
        title: 'Szerkezet',
        subtitle: 'Szekciók és könyvek — a tudástár váza.',
        newSpace: 'Új szekció',
        newCategory: 'Új könyv',
        rename: 'Átnevezés',
        appearance: 'Megjelenés',
        makePublic: 'Nyilvánossá',
        makeInternal: 'Belsővé',
        // A KÖNYV nyilvánossá tétele után felajánljuk a benne lévő PUBLIKÁLT cikkek kitételét. Nem
        // automatikus: a publikálás cikk-szintű bizalmi döntés (egy könyvben lehet belső jegyzet),
        // ezért a kérdés kimondja a darabszámot, és a vázlatokra SOHA nem terjed ki.
        confirmPublishArticles:
          'A könyv nyilvános lett. {{count}} publikált cikk van benne — kitegyem mindet a súgóra? (A vázlatok nem kerülnek ki.)',
        publishArticlesDone: '{{count}} cikk kikerült a súgóra.',
        publishArticlesNone: 'Egy cikk sem került ki — mindegyik már kint volt.',
        publishArticlesPartial:
          '{{published}} cikk kikerült, {{failed}} nem sikerült: {{titles}}. Próbáld újra, vagy tedd ki egyenként.',
        appearanceColor: 'Szín',
        appearanceIcon: 'Ikon',
        appearanceAuto: 'Automatikus',
        saving: 'Mentés…',
        archive: 'Archiválás',
        unarchive: 'Visszahozás',
        archived: 'archivált',
        namePlaceholder: 'Név',
        descriptionPlaceholder: 'Rövid leírás (nem kötelező)',
        save: 'Mentés',
        cancel: 'Mégse',
        empty: 'Még nincs szekció.',
        loadError: 'A szerkezet betöltése nem sikerült.',
        articleCount: '{{count}} cikk',
        emptySpace: 'Nincs könyv ebben a szekcióban.',
        editMode: 'Szerkesztés',
        editModeOn: 'Szerkesztés kész',
        deleteSpace: 'Szekció törlése',
        deleteCategory: 'Könyv törlése',
        confirmDeleteSpace: 'Törlöd a(z) „{{name}}" szekciót? Ez nem visszavonható.',
        confirmDeleteCategory: 'Törlöd a(z) „{{name}}" könyvet? Ez nem visszavonható.',
        // A szekció-oldali változatok KIMONDJÁK a következményt is: a szerver csak ÜRES elemet
        // engedi törölni (a gomb addig tiltott), tehát tartalom nem veszhet el — a felhasználónak
        // ezt nem kell kitalálnia. Az archiválás visszafordítható alternatívaként meg is van nevezve.
        confirmDeleteSpaceEmpty:
          'Törlöd a(z) „{{name}}" szekciót? Üres, tehát tartalom nem veszik el — de a törlés maga nem visszavonható. Ha csak elrejtenéd, használd az Archiválást.',
        confirmDeleteCategoryEmpty:
          'Törlöd a(z) „{{name}}" könyvet? Üres (a papírkosárban sincs cikk), tehát tartalom nem veszik el — de a törlés maga nem visszavonható.',
        deleteBlockedSpace:
          'Nem törölhető: {{count}} könyv van benne. Előbb helyezd át vagy töröld őket.',
        deleteBlockedCategory:
          'Nem törölhető: {{live}} cikk, és {{trashed}} a papírkosárban. A papírkosárban lévő cikk is akadály — azt is ki kell üríteni.',
        moveArticle: 'Áthelyezés…',
        moveTarget: 'Cél-könyv',
        moveFilter: 'Szekció vagy könyv szűrése',
        moveEmpty: 'Nincs másik könyv, ahova át lehetne helyezni.',
        dragHandle: 'Átrendezés: {{name}}',
        // A dnd-kit képernyőolvasó-bejelentései — enélkül a húzás billentyűzettel követhetetlen.
        dragStart: 'Felemelve. A nyilakkal mozgathatod, szóközzel leteszed, Esc-kel elveted.',
        dragEnd: 'Letéve. A sorrend mentése folyamatban.',
        dragCancel: 'Elvetve, a sorrend nem változott.',
      },
      attachments: {
        title: 'Csatolmányok',
        upload: 'Fájl feltöltése',
        uploading: 'Feltöltés…',
        empty: 'Ehhez a cikkhez még nincs csatolmány.',
        // A hibaág üzenete SZÁNDÉKOSAN nem technikai: az upstream státusz a naplóba tartozik, nem a
        // felhasználó képernyőjére. Azt viszont ki kell mondani, hogy a lista NEM üres, csak nem
        // tölthető be — különben a felhasználó azt hiszi, nincsenek csatolmányai, és újra feltölti.
        loadFailed: 'A csatolmányok listája most nem tölthető be. A feltöltés ettől függetlenül működik.',
        insert: 'Beszúrás',
        uploaded: '{{filename}} feltöltve és beszúrva.',
        failed: 'A feltöltés nem sikerült.',
        prepareFailed: 'A feltöltés előkészítése nem sikerült',
        // A böngésző a lap CSP-je miatt el sem indította a kérést a tár felé. SZÁNDÉKOSAN
        // megnevezi az okot: enélkül ez „általános hiba", és a felhasználó újrapróbálgatja
        // valamit, ami sosem fog menni (élesben így ment el három diagnózis-kör).
        cspBlocked:
          'A böngésző biztonsági szabályzata nem engedi a fájl-tár elérését (CSP connect-src). Ez üzemeltetői beállítás, az újrapróbálás nem segít — szólj az üzemeltetőnek. A cikk szövegét közben mentheted.',
        uploadFailed: 'A fájl feltöltése nem sikerült',
        commitFailed: 'A fájl véglegesítése nem sikerült',
        tooLarge: 'A fájl túl nagy (legfeljebb {{max}} MB).',
        remove: 'Törlés',
        removeBlocked:
          '{{filename}} még használatban van: a cikk hivatkozik rá. Előbb vedd ki a szövegből.',
        removeUnsaved:
          '{{filename}} hivatkozását kivetted, de még nem mentetted. Mentsd el a cikket, utána törölhető.',
        confirmRemove: 'Biztosan törlöd a(z) {{filename}} fájlt? Ez nem visszavonható.',
        removed: '{{filename}} törölve.',
        removeFailed: 'A csatolmány törlése nem sikerült.',
        unused: 'Nincs használatban',
      },
      comments: {
        /** Művelet-megnevezés a hibaüzenet-kontextushoz („A hozzászólás nem sikerült: <ok>"). */
        operation: 'A hozzászólás nem sikerült',
        title: 'Hozzászólások',
        internalNote: 'Belső beszélgetés — az ügyfelek nem látják.',
        empty: 'Még nincs hozzászólás. Kérdezz, vagy jelezd, mi hiányzik a cikkből.',
        placeholder: 'Írj hozzászólást…',
        replyPlaceholder: 'Válasz…',
        reply: 'Válasz',
        send: 'Küldés',
        sending: 'Küldés…',
        cancel: 'Mégse',
        resolve: 'Lezárás',
        reopen: 'Újranyitás',
        resolved: 'Lezárva',
        delete: 'Törlés',
        unknownAuthor: 'ismeretlen szerző',
        loadError: 'A hozzászólások betöltése nem sikerült.',
      },
      revisions: {
        /** Művelet-megnevezés a hibaüzenet-kontextushoz. */
        restoreOperation: 'A visszaállítás nem sikerült',
        title: 'Változástörténet',
        open: 'Változástörténet',
        backToEditor: 'Vissza a szerkesztőhöz',
        empty: 'Ehhez a cikkhez még nincs mentett korábbi változat.',
        loadError: 'A változástörténet betöltése nem sikerült.',
        current: 'Jelenlegi változat',
        currentHint: 'Ez a most élő tartalom.',
        /** Ha nem tudjuk, melyik változás hozta létre az állapotot — lásd lib/revision-origin.ts. */
        originUnknown: 'A létrehozó változás nincs rögzítve.',
        item: '{{revision}}. változat',
        unknownAuthor: 'ismeretlen szerkesztő',
        source: {
          editor: 'szerkesztés',
          import: 'importálás',
          restore: 'visszaállítás',
        },
        compare: 'Összehasonlítás',
        compareHint: 'Válaszd ki, melyik változattól melyikig nézed az eltérést.',
        compareFromColumn: 'Innen',
        compareToColumn: 'Eddig',
        compareFrom: '„Innen" kijelölése: {{revision}}',
        compareTo: '„Eddig" kijelölése: {{revision}}',
        diffTitle: '{{from}} → {{to}}',
        diffEmpty: 'A két változat tartalma azonos.',
        diffStats: '{{added}} sor hozzáadva, {{removed}} sor törölve',
        diffCollapsed: '… {{count}} változatlan sor …',
        restore: 'Visszaállítás',
        restoring: 'Visszaállítás…',
        restoreConfirm:
          'Biztosan visszaállítod a(z) {{revision}}. változatot? A jelenlegi tartalomról előbb új bejegyzés készül a történetbe, tehát visszavonható.',
        restoreNoPermission: 'A visszaállításhoz nincs jogosultságod.',
      },
    },
    validation: {
      email: 'Érvényes e-mail címet adj meg.',
      required: 'Kötelező mező.',
      titleRequired: 'A cím nem lehet üres.',
    },
    toast: {
      loggedOut: 'Kijelentkeztél.',
      articleSaved: 'A cikk elmentve.',
      articleSaveFailed: 'A mentés nem sikerült — próbáld újra.',
      draftDiscarded: 'A vázlat eldobva.',
      revisionRestored: 'A(z) {{revision}}. változat visszaállítva.',
      revisionRestoreFailed: 'A visszaállítás nem sikerült.',
      commentAdded: 'Hozzászólás elküldve.',
      commentDeleted: 'A hozzászólás törölve.',
      commentFailed: 'A művelet nem sikerült — próbáld újra.',
      articleRestored: 'A cikk visszaállítva — vázlatként találod.',
      articleRestoreFailed: 'A visszaállítás nem sikerült.',
      articleCreated: 'A cikk létrehozva — most már írhatsz bele.',
      articleCreateFailed: 'A cikk létrehozása nem sikerült.',
      spaceCreated: 'A szekció létrehozva.',
      categoryCreated: 'A könyv létrehozva.',
      structureSaved: 'Mentve.',
      structureFailed: 'A művelet nem sikerült.',
      moved: 'A cikk áthelyezve.',
      moveFailed: 'Az áthelyezés nem sikerült.',
      statusChanged: 'Az állapot frissítve.',
      statusChangeFailed: 'Az állapot módosítása nem sikerült.',
      statusChangeConflict: 'A cikket időközben más módosította — tölts újra.',
      revisionRestoreConflict:
        'A cikket időközben más módosította — töltsd újra, mielőtt visszaállítasz.',
    },
    /**
     * HIBA-ÜZENETEK a szerver gépi kódjaihoz (`HubErrorCode`). Egy kulcs = egy VALÓDI helyzet.
     *
     * Írás-szabályok, mert a hibaüzenet a legrosszabb pillanatban olvasott szöveg:
     *  1. Mondd meg, MI történt — röviden, hibáztatás nélkül.
     *  2. Mondd meg, MI A KÖVETKEZŐ LÉPÉS. Ha nincs mit tenni, azt is mondd ki („az újrapróbálás nem
     *     segít") — a hamis remény rosszabb, mint a rossz hír.
     *  3. Nyugtass meg, ha nem veszett el adat (ütközésnél ez a legfontosabb információ).
     *  4. Ne szivárogtass belső részletet (jog-kulcs, útvonal, upstream-válasz) — az a naplóba tartozik.
     */
    errors: {
      /** A `message` nélküli, ismeretlen eset — a végső tartalék. */
      unknown: 'Váratlan hiba történt. Töltsd újra az oldalt, és próbáld meg még egyszer.',

      unauthenticated: 'A munkamenet lejárt. Jelentkezz be újra, és folytathatod.',
      permission_denied:
        'Ehhez a művelethez nincs jogosultságod. Ha szükséged van rá, kérd az adminisztrátortól — a jogokat az Atlasban osztják.',
      not_found: 'Nem találjuk — lehet, hogy időközben törölték vagy áthelyezték.',
      invalid_request:
        'A kérés hibás volt. Töltsd újra az oldalt, és próbáld meg még egyszer — így általában megoldódik.',
      validation_failed: 'A megadott tartalom nem felel meg a követelményeknek.',
      conflict:
        'Időközben más is módosította ezt a tartalmat. A te változatod NEM íródott felül: töltsd újra az oldalt, és utána mentsd el újra.',
      rate_limited: 'Túl sok kérés futott be rövid idő alatt. Várj egy percet, aztán próbáld újra.',

      /**
       * A legfontosabb üzenet: ezt a helyzetet a felhasználó NEM tudja megoldani, és az újrapróbálás
       * sem segít. Korábban erre is „a művelet nem sikerült — próbáld újra" jött, ami háromszor
       * hazudott: nem az ő hibája, nem múló, és az újrapróbálás értelmetlen.
       */
      service_identity_missing:
        'A szerkesztés és a hozzászólás jelenleg nem működik: a tudástár rendszer-fiókja beállításra vár. Ez nem a te hibád, és az újrapróbálás sem segít — szólj az üzemeltetőnek. Az olvasás és a keresés közben zavartalanul működik.',

      /**
       * Szándékosan SZŰKEBB állítás, mint a `service_identity_missing`: itt csak a fájl-műveletek
       * állnak, a szöveg-szerkesztés nem. Ha a felhasználónak azt mondanánk, hogy „a szerkesztés nem
       * működik", elállnánk egy olyan munkától, amit el tud végezni.
       */
      file_tenant_missing:
        'Kép és csatolmány jelenleg nem tölthető fel: a fájl-tár beállítása hiányzik. Ez nem a te hibád, és az újrapróbálás sem segít — szólj az üzemeltetőnek. A cikk szövegét közben mentheted.',

      internal_tenant_missing:
        'A művelet most nem végezhető el: a Hub belső ügyfél-rekordja nincs beállítva. Ez nem a te hibád, és az újrapróbálás sem segít — szólj az üzemeltetőnek.',

      upstream_unavailable:
        'A rendszer épp nem elérhető. Próbáld újra pár perc múlva — a munkád nem veszett el.',
      index_unavailable:
        'A keresés jelenleg nem elérhető. A tudástár böngészése és az olvasás közben működik.',
      internal_error:
        'Váratlan hiba történt a kiszolgálón. Próbáld újra; ha ismét előfordul, jelezd az üzemeltetőnek.',

      /** Művelet-kontextus a kód-alapú ok előtt (pl. „A mentés nem sikerült: <ok>"). */
      withOperation: '{{operation}}: {{reason}}',

      /**
       * MEGELŐZŐ jelzés — a művelet HELYÉN, mielőtt a felhasználó belefutna. Rövidebb, mint a
       * hiba-üzenet: itt még nem történt baj, csak azt mondjuk meg, mi nem megy és miért.
       *
       * A korábbi globális sáv (a fejléc alatt, minden oldalon, mindenkinek) helyére jött: az a sáv
       * ott is ott volt, ahol semmi írható elem nincs, és annak is szólt, akinek a szerkesztés jog
       * szerint sem elérhető — ez a változat viszont pontosan ott jelenik meg, ahol akadály.
       */
      readOnlyNotice: {
        comments: 'A hozzászólás jelenleg nem működik: a rendszer-fiók beállításra vár.',
        editing: 'A szerkesztés jelenleg nem működik: a rendszer-fiók beállításra vár.',
        /** A jelzés mellé kerülő magyarázat — miért nem érdemes próbálkozni. */
        hint: 'Ez nem a te hibád, és az újrapróbálás sem segít — szólj az üzemeltetőnek. Az olvasás és a keresés közben működik.',
      },
    },
  },
} as const;

void i18n.use(initReactI18next).init({
  resources,
  lng: 'hu',
  fallbackLng: 'hu',
  interpolation: { escapeValue: false },
  returnEmptyString: false,
});

export default i18n;
